import { Checkbox, NumberInput } from '@makyoapp/makyo-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { MAX_ROWS_LIMIT } from '@/shared/constants'

const DataSetLimitInput = ({
  id,
  settingId,
  value,
  label = 'Limit number of items',
}: {
  id: string
  settingId: string
  value: any
  label?: string
}) => {
  const updateValue = useUpdateCompSettingValue(id)
  const v = value as { enabled: boolean; value: number } | undefined

  return (
    <div className='flex items-center gap-4 w-full justify-between'>
      <Checkbox
        id={`${settingId}-enabled`}
        className='justify-start'
        checked={v?.enabled ?? false}
        onClick={async (checked) => {
          await updateValue({
            ...(v ?? { value: 100 }),
            enabled: checked,
          })
        }}
        label={label}
      />
      <NumberInput
        id={settingId}
        min={1}
        max={MAX_ROWS_LIMIT}
        value={v?.value ?? 100}
        disabled={!v?.enabled}
        onChange={async (n) => {
          await updateValue({
            ...(v ?? {}),
            value: n,
          })
        }}
      />
    </div>
  )
}

export default DataSetLimitInput
